export const cuisineTypes = [
    "african",
    "american",
    "andalusian",
    "arab",
    "argentine",
    "rice_dishes",
    "grill",
    "asian",
    "asturian",
    "belgian",
    "brazilian",
    "castilian",
    "catalan",
    "chinese",
    "colombian",
    "korean",
    "creperie",
    "fusion",
    "spanish",
    "ethiopian",
    "french",
    "galician",
    "greek",
    "indian",
    "english",
    "international",
    "iranian",
    "italian",
    "japanese",
    "latin",
    "lebanese",
    "seafood",
    "moroccan",
    "mediterranean",
    "mexican",
    "peruvian",
    "portuguese",
    "swiss",
    "thai",
    "traditional",
    "turkish",
    "basque",
    "vegetarian",
    "venezuelan",
    "vietnamese"
]
